function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M262.2 176.8c-.1-39-31.7-70.6-70.7-70.6h-75.4l-15.3-70.6v-.2c-5.7-24.6-30.3-40-55-34.3L0 11.8l21.3 96.5v153.8h14.1v21.3h28.3v-21.3h156v21.3H248v-21.3h14.1l.1-85.3zm-28.5 0v56.9H49.8v-99h141.7c23.3 0 42.1 18.8 42.2 42.1zM52.2 28.9c9.3-2.1 18.5 3.6 20.8 12.9l14 64.4H50l-16.1-73 18.3-4.3z"
})));